import _ from 'lodash'
import * as React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Card, CardText } from 'reactstrap'

import { getGroup, selectGroupsStatus } from 'slices/groupsSlice'
import { selectSessionStatus, setTeamWorker } from 'slices/sessionSlice'

import { WorkerIcon } from 'components/common'
import { ColorTypes } from 'components/common/utils'

import useLogout from 'hooks/useLogout'

import styles from './styles.module.scss'

const TeamSelectWorkers: React.FC = () => {
  const dispatch = useDispatch()
  const {
    team: { workspaceId, groupId, groupName },
  } = useSelector(selectSessionStatus, shallowEqual)
  const { logout } = useLogout()

  React.useEffect(() => {
    dispatch(getGroup(workspaceId, groupId))
  }, [dispatch, workspaceId, groupId])

  const groupsStatus = useSelector(selectGroupsStatus, shallowEqual)
  const group = React.useMemo(() => _.find(groupsStatus.groups, { groupId }), [groupsStatus, groupId])
  const workers = _.sortBy(group?.workers, 'name')

  const navigate = useNavigate()
  const moveToAssignment = (workerId: number, workerName: string) => {
    dispatch(setTeamWorker({ workerId, workerName }))
    navigate('/team-assignment')
  }

  return (
    <>
      <div className={`d-flex justify-content-between align-items-center px-2 ${styles.header}`}>
        <i className="icf-chevron_left font-x-large" onClick={() => navigate('/team-select-groups')} />
        <div className="font-x-large fw-bold">操作メンバー選択</div>
        <div onClick={() => logout()}>ログアウト</div>
      </div>
      <div className={`position-sticky ${styles.list}`}>
        {workers.map(worker => (
          <Card
            className="p-3 mb-2"
            key={worker.workerId}
            onClick={() => moveToAssignment(worker.workerId, worker.name)}
          >
            <div className="d-flex justify-content-start align-items-center">
              <WorkerIcon name={worker.name} groupColor={group?.color || ColorTypes.Silver} />
              <div className="px-3 overflow-hidden">
                <CardText className="m-0 text-truncate">{worker.name}</CardText>
                <CardText className="m-0 text-truncate fw-light text-black-50">{groupName}</CardText>
              </div>
              <i className="ms-auto icf-chevron_right font-large" />
            </div>
          </Card>
        ))}
      </div>
    </>
  )
}

export default TeamSelectWorkers
